var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeScanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.75V0H3.75V1.5H1.5V3.75H0ZM0 15V11.25H1.5V13.5H3.75V15H0ZM11.25 15V13.5H13.5V11.25H15V15H11.25ZM13.5 3.75V1.5H11.25V0H15V3.75H13.5ZM11.625 11.625H12.75V12.75H11.625V11.625ZM11.625 9.375H12.75V10.5H11.625V9.375ZM10.5 10.5H11.625V11.625H10.5V10.5ZM9.375 11.625H10.5V12.75H9.375V11.625ZM8.25 10.5H9.375V11.625H8.25V10.5ZM10.5 8.25H11.625V9.375H10.5V8.25ZM9.375 9.375H10.5V10.5H9.375V9.375ZM8.25 8.25H9.375V9.375H8.25V8.25ZM12.75 2.25V6.75H8.25V2.25H12.75ZM6.75 8.25V12.75H2.25V8.25H6.75ZM6.75 2.25V6.75H2.25V2.25H6.75ZM5.625 11.625V9.375H3.375V11.625H5.625ZM5.625 5.625V3.375H3.375V5.625H5.625ZM11.625 5.625V3.375H9.375V5.625H11.625Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeScanner);
export default __webpack_public_path__ + "static/media/qr_code_scanner.9183611edb7980ccb2fdead0593a290d.svg";
export { ForwardRef as ReactComponent };